import React from 'react';
import { startOfDay, subDays, subMonths, getDate } from 'date-fns';
import { CustomLabelWithTooltip } from 'src/components/common/CustomLabelWithTooltip/CustomLabelWithTooltip';
import { BaseDateInput } from 'src/components/enterprise/components/BaseDateInput/BaseDateInput';
import { ReportDateRangeTooltipContent } from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/ReportDateRangeTooltipContent/ReportDateRangeTooltipContent';

interface StartDateControlProps {
  name: string;
  id: string;
}

export const StartDateControl: React.FC<StartDateControlProps> = ({
  name,
  id,
}) => {
  const startDateLabel = 'Start Date *';
  const today = startOfDay(new Date());
  const initialMonth = getDate(today) === 1 ? subMonths(today, 1) : today;

  return (
    <BaseDateInput
      id={id}
      name={name}
      ariaLabel={startDateLabel}
      label={
        <CustomLabelWithTooltip
          labelText={startDateLabel}
          tooltipInfo={<ReportDateRangeTooltipContent />}
        />
      }
      blockWidth
      rules={{
        required: 'Start Date is required',
      }}
      disabledDays={{
        after: subDays(today, 1),
      }}
      initialMonth={initialMonth}
    />
  );
};
